import AuditTrail from "../audit.trail";

export const TextAreaLog = (WrappedComponent) => (props) => {
  const { onBlur, event, eventParams, ...otherProps } = props;

  const onLog = (event, action, eventParams) => {
      if (event) {
          const label = props.label? props.label : (props._label? props._label: '')
          AuditTrail.sendLog(event, Object.assign({tag: 'textarea', event: action, label: label}, eventParams));
      }
  }

  return (
    <WrappedComponent
        {...otherProps}
        onBlur={(context) => {
            onLog(event, 'onBlur', eventParams);
            if (props.onBlur) {
                props.onBlur(context);
            }
        }}
    />
  );
};
